export default "__VITE_ASSET__6468ab53__"